import { all } from "redux-saga/effects";
import loaderSaga from "./loader/loaderSaga";
import tabSaga from "./tabs/tagSaga";
// import userSearchSaga from "./user-search/userSearchSaga";

export default function* rootSaga() {
  yield all([
    loaderSaga(),
    tabSaga()
    // userSearchSaga()
  ]);
}
